import {
  InstructionsStep,
  PromptStep,
  RecapStep,
  type ListeningPart,
  YesNoQuestion,
  StudentSelectQuestion,
} from "./steps";

export const listeningSteps: ListeningPart[] = [
  {
    key: "instructions",
    requestStep: "instructions",
    shouldFetch: true,
    component: InstructionsStep,
    componentProps: {
      instructionType: "overall",
    },
  },
  {
    key: "part1-prompt",
    requestStep: "instructions",
    shouldFetch: true,
    includePart: true,
    partOrder: 1,
    requiresCompletion: true,
    component: PromptStep,
  },
  {
    key: "part1-yesNo-instructions",
    requestStep: "part1-prompt",
    shouldFetch: false,
    component: InstructionsStep,
    componentProps: {
      instructionType: "yes_no",
    },
  },
  {
    key: "part1-yesNo",
    requestStep: "part1-yesNo-instructions",
    shouldFetch: false,
    requiresCompletion: true,
    component: YesNoQuestion,
  },
  {
    key: "part1-student-select-instructions",
    requestStep: "part1-yesNo",
    shouldFetch: false,
    component: InstructionsStep,
    componentProps: {
      instructionType: "student_select",
    },
  },
  {
    key: "part1-student-select",
    requestStep: "part1-student-select-instructions",
    shouldFetch: false,
    requiresCompletion: true,
    component: StudentSelectQuestion,
  },
  {
    key: "part2-prompt",
    requestStep: "part1-student-select",
    shouldFetch: true,
    includePart: true,
    partOrder: 2,
    requiresCompletion: true,
    component: PromptStep,
  },
  {
    key: "part2-yesNo",
    requestStep: "part2-prompt",
    shouldFetch: false,
    requiresCompletion: true,
    component: YesNoQuestion,
  },
  {
    key: "part2-student-select",
    requestStep: "part2-yesNo",
    shouldFetch: false,
    requiresCompletion: true,
    component: StudentSelectQuestion,
  },
  {
    key: "part3-prompt",
    requestStep: "part2-student-select",
    shouldFetch: true,
    includePart: true,
    partOrder: 3,
    requiresCompletion: true,
    component: PromptStep,
  },
  {
    key: "part3-yesNo",
    requestStep: "part3-prompt",
    shouldFetch: false,
    requiresCompletion: true,
    component: YesNoQuestion,
  },
  {
    key: "part3-student-select",
    requestStep: "part3-yesNo",
    shouldFetch: false,
    requiresCompletion: true,
    component: StudentSelectQuestion,
  },
  {
    key: "listening-recap",
    requestStep: "part3-student-select",
    shouldFetch: false,
    requiresCompletion: true,
    lastStep: true,
    component: RecapStep,
  },
];
